<template>
  <loading v-if="loading" />

  <div id="wrapper" class="noheader" v-if="checkInfo.length">
    <div class="lineCheckinBox">
      <div class="box" v-for="(c, idx) in checkInfo" :key="idx">
        <img
          :src="
            `https://assets.musoon.clinic/images/checkin/${c.clinic}${c.dept}${c.room}_icon.jpg`
          "
          @click="view = 'detail'"
        />

        <div class="modalBox type3" v-if="view === 'detail'">
          <a class="closeBtn" @click="view = null"
            ><img src="@/assets/images/modal_close.svg" width="24" /><span
              >關閉</span
            ></a
          >
          <div class="inner">
            <img
              :src="
                `https://assets.musoon.clinic/images/checkin/${c.clinic}${c.dept}${c.room}_orig.jpg`
              "
            />
          </div>
        </div>

        <div class="txt">
          <div class="top">
            <div class="left">
              <h2 class="number">{{ c.number }}</h2>
              <p>候診號碼</p>
            </div>
            <div class="right">
              <h2>{{ c.name }}</h2>
              <p>
                {{ c.dept }}&nbsp;{{ c.room }}&nbsp; {{ c.doctor }}&nbsp;醫師
              </p>
            </div>
          </div>
          <div class="bottom">
            <p>{{ c.message }}</p>
          </div>
        </div>
      </div>
      <p class="txt" style="text-align:left;">
        木生婦幼非常感謝您蒞臨，請您留意上面的候診號碼，並留意各診叫號情況，如果候診人數較多時，再請您耐心等候
        !!
      </p>
      <div class="reminder">
        請點選右上角 ✕ 圖示<br />
        回到 LINE 主畫面
      </div>
    </div>
  </div>

  <div v-else-if="response.code === 'binding'">
    <div id="wrapper" class="noheader signing">
      <div class="kv login app covershow"><div class="cover"></div></div>
      <div class="content" style="padding-top: 66%;">
        <h1 class="app">邀請您加入木生 LINE 好友</h1>
        <div class="doneBox">
          <p style="text-align:justify;">
            加入好友後於功能選單中的『首頁』完成帳號綁定，以後就能直接用LINE快速報到喔！
          </p>
        </div>
      </div>
    </div>
    <div id="wrapper">
      <div class="content">
        <div class="formBox">
          <form action="javascript:void(0);">
            <input
              type="submit"
              class="submitBtn"
              style="background-color: #57c248;"
              value="加入木生 LINE 好友"
              @click.prevent="binding()"
            />
          </form>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div id="wrapper" class="noheader signing">
      <div class="kv login app covershow"><div class="cover"></div></div>
      <div class="content" style="padding-top: 66%;">
        <h1 class="app">請至櫃檯完成報到</h1>
        <div class="doneBox">
          <p style="text-align:justify;">
            很抱歉，您的預約需至櫃檯才能完成報到，請您先抽號碼等待櫃檯叫號，造成您的不便還請見諒。
          </p>
        </div>
      </div>
    </div>

    <div id="wrapper">
      <div class="content">
        <div class="formBox">
          <form action="javascript:void(0);">
            <input
              type="submit"
              class="submitBtn"
              value="開啟木生LINE官方帳號"
              @click.prevent="$router.replace('/HomePage')"
            />
          </form>
          <div
            style="margin: 1rem; color:#f19e4e; font-weight:bold; line-height:1.6rem"
          >
            ＊提醒您～
            現場報到後，請打開手機推播功能，及調整音量，方便推播叫號。
          </div>
        </div>
      </div>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>

  <debug v-if="debug">{{ response }}</debug>
</template>

<script>
import liff from "@line/liff";
import api from "../api/index";

export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {},
      view: null,
      checkInfo: [],
      response: { code: null }
    };
  }, //datad
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  mounted() {
    if (this.member.platform === "develop") {
      this.member.params.qrcode =
        "c82a86a9f9ac401d9b9ec31985d6a6c7fea6df15ede58e26f8d68942c35157de";
    }
    this.CheckIn();
  },
  methods: {
    binding() {
      liff.openWindow({
        url: "https://lin.ee/d1gmgrT",
        external: false
      });
    },
    CheckIn() {
      api.visit.liff
        .scan({
          jwt: this.member.jwt,
          qrcode: this.member.params.qrcode
        })
        .then(checkinInfo => {
          console.log(checkinInfo);
          this.response = checkinInfo; //Debug用
          this.loading = false;
          this.checkInfo = checkinInfo;
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "報到失敗",
            body: error.message
          };
        });
    }
  }
};
</script>

<style scoped>
.reminder {
  margin: 5rem 1rem;
  padding: 1rem 0;
  border: solid 2px #f28e2a;
  border-radius: 0.618rem;
  text-align: center;
  font-size: 1.618rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.1rem;
  color: #f28e2a;
}
</style>
